export function toAutoKML(data) {
  // 이미 KML인지 체크
  if (typeof data === "string" && data.includes("<?xml")) {
    return data;
  }

  // PATH 좌표 (lon,lat,alt)
  const pathCoordinates =
    data.waypointDetails?.map((p) => `${p.x},${p.y},${p.z}`).join(" ") || "";

  // 장애물 KML 요소
  const obstacleElements =
    data.obstacles
      ?.map((obs) => {
        const obstacleCoordinates = obs.points
          .map((pt) => `${pt.x},${pt.y},${pt.z}`)
          .join(" ");

        const colorHex = (obs.areaType?.typeColor || "#FF0066").replace(
          "#",
          ""
        );

        return `
          <Placemark>
            <name>${obs.name || "장애물"}</name>
  
            <ExtendedData>
              <Data name="type"><value>OBSTACLE</value></Data>
              <Data name="obstacleId"><value>${obs.id}</value></Data>
              <Data name="areaTypeId"><value>${
                obs.areaType?.id || ""
              }</value></Data>
              <Data name="areaTypeName"><value>${
                obs.areaType?.typeName || ""
              }</value></Data>
              <Data name="areaTypeColor"><value>${
                obs.areaType?.typeColor || ""
              }</value></Data>
            </ExtendedData>
  
            <Style>
              <PolyStyle>
                <color>80${colorHex}</color>
                <fill>1</fill>
                <outline>1</outline>
              </PolyStyle>
              <LineStyle>
                <color>FF${colorHex}</color>
                <width>2</width>
              </LineStyle>
            </Style>
  
            <Polygon>
              <extrude>1</extrude>
              <altitudeMode>absolute</altitudeMode>
              <outerBoundaryIs>
                <LinearRing>
                  <coordinates>${obstacleCoordinates}</coordinates>
                </LinearRing>
              </outerBoundaryIs>
            </Polygon>
          </Placemark>
          `;
      })
      .join("") || "";

  // 최종 KML
  return `
  <?xml version="1.0" encoding="UTF-8"?>
  <kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>
  
    <name>${data.name || "농기구 경로"}</name>
  
    <!-- 공통 메타데이터 -->
    <ExtendedData>
      <Data name="projectId"><value>${data.projectId}</value></Data>
      <Data name="routeId"><value>${data.id}</value></Data>
      <Data name="name"><value>${data.name}</value></Data>
      <Data name="workType"><value>${data.workType}</value></Data>
      <Data name="description"><value>${data.description || ""}</value></Data>
      <Data name="createdAt"><value>${data.createdAt}</value></Data>
  
      <!-- equipment 정보 (GeoJSON과 동일) -->
      <Data name="equipmentId"><value>${
        data.agriculturalEquipmentId
      }</value></Data>
      <Data name="equipmentName"><value>${
        data.equipmentSpec?.name || ""
      }</value></Data>
      <Data name="equipmentWidth"><value>${
        data.equipmentSpec?.width || ""
      }</value></Data>
      <Data name="equipmentWheelbase"><value>${
        data.equipmentSpec?.wheelBase || ""
      }</value></Data>
      <Data name="equipmentSteerDeg"><value>${
        data.equipmentSpec?.steeringAngle || ""
      }</value></Data>
      <Data name="equipmentTurningRadius"><value>${
        data.equipmentSpec?.turningRadius || ""
      }</value></Data>
      <Data name="equipmentVehicleLength"><value>${
        data.equipmentSpec?.vehicleLength || ""
      }</value></Data>
    </ExtendedData>
  
    <!-- PATH 스타일 -->
    <Style id="pathStyle">
      <LineStyle>
        <color>ff00ffff</color>
        <width>4</width>
      </LineStyle>
    </Style>
  
    <!-- PATH 좌표 -->
    <Placemark>
      <name>PATH</name>
      <ExtendedData>
        <Data name="type"><value>PATH</value></Data>
        <Data name="routeId"><value>${data.id}</value></Data>
        <Data name="projectId"><value>${data.projectId}</value></Data>
      </ExtendedData>
      <styleUrl>#pathStyle</styleUrl>
      <LineString>
        <extrude>1</extrude>
        <altitudeMode>absolute</altitudeMode>
        <coordinates>${pathCoordinates}</coordinates>
      </LineString>
    </Placemark>
  
    <!-- 장애물 -->
    ${obstacleElements}
  
  </Document>
  </kml>
  `;
}
